import { createFeatureSelector, createSelector, MemoizedSelector } from '@ngrx/store';
import { SearchServiceModel } from './model';
import { adapter, SearchServiceState } from './state';

export const stateName: string = 'searchService';
export const selectEntityState: MemoizedSelector<object, SearchServiceState> = createFeatureSelector<SearchServiceState>(stateName);

export const getError = (state: SearchServiceState): any => state.error;
export const getIsLoading = (state: SearchServiceState): boolean => state.isLoading;
export const getSelected = (state: SearchServiceState): SearchServiceModel => state.selected;

export const selectError: MemoizedSelector<object, any> = createSelector(selectEntityState, getError);
export const selectIsLoading: MemoizedSelector<object, boolean> = createSelector(selectEntityState, getIsLoading);
export const selectSelected: MemoizedSelector<object, SearchServiceModel> = createSelector(selectEntityState, getSelected);

export const selectAll: (state: object) => SearchServiceModel[] = adapter.getSelectors(selectEntityState).selectAll;
